import Base from './Base';
import DateFormats from './DateFormats';

export default class Maintenance extends Base {
  id: number;
  areaId: number;
  areaName: string;
  propertyId: number;
  contactId: number;
  dateCreated: string;
  message: string;
  handymanComments: string;
  contractorNotes: string;
  showExpectedCost: boolean;
  expectedCost: number;
  photos: string[];

  constructor(data: any) {
    super();
    this.id = data.id;
    this.areaId = data.areaId;
    this.areaName = data.areaName;
    this.contactId = data.contactId;
    this.dateCreated = data.dateCreated;
    this.message = data.message;
    this.propertyId = data.propertyId;
    this.handymanComments = data.handymanComments;
    this.contractorNotes = data.contractorNotes;
    this.showExpectedCost = data.showExpectedCost;
    this.expectedCost = data.expectedCost;
    this.photos = data.photos;
  }

  static parseFromData(data: any): Maintenance {
    return new Maintenance({
      id: data.id,
      areaId: data.area_id,
      areaName: data.area_name,
      contactId: data.contact_id,
      dateCreated: data.date_created,
      message: data.message,
      propertyId: data.property_id,
      handymanComments: data.handyman_comments,
      contractorNotes: data.contractor_notes,
      showExpectedCost: data.show_expected_cost,
      expectedCost: data.task_expected_cost,
      photos: data.photos,
    });
  }

  getDateCreated(dateFormat: string): string {
    return this.getDateFromSQL(
      this.dateCreated,
      dateFormat || DateFormats.DATE_TIME
    );
  }
}
